import { render, staticRenderFns } from "./KioskGlobalUpdated.vue?vue&type=template&id=5a01cc28"
import script from "./KioskGlobalUpdated.vue?vue&type=script&lang=js"
export * from "./KioskGlobalUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports